import React from 'react';
import { connect } from 'react-redux';
import Container from "@material-ui/core/Container";
import { bindActionCreators } from 'redux';
import { actionCreators as authActions } from '../redux/actions/authActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import LockIcon from '@material-ui/icons/Lock';
import * as authHelpers from './authHelpers';
import * as routeHelpers from './routeHelpers';
import './auth.css';
import Alert from '@material-ui/lab/Alert';
import LoadingAlert from './../components/LoadingAlert'; 

class GuestVerification extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			code: '',
			errorMessage: '',
			successMessage: '',
			unlockCode2IsInvalid: true,
			statusMessage: 'Verifying link and sending you a one-time code.'
		};
	}

	componentDidMount() {
		let user = authHelpers.getAuthUser();
		if (user) {
			this.props.history.push(routeHelpers.buildRoute("")); //navigate to ID Verification component
		}
		else {
			this.sendVerificationCode();
		}
	}

	resetFormAndShowError(error) {
		this.setState((state) => ({
			...state,
			errorMessage: error,
			successMessage: '',
			code: '',
			statusMessage: ''
		}));
	}

	handleSubmit = (event) => {
		event.preventDefault();

		this.setState((state) => ({
			...state,
			errorMessage: '',
			successMessage: ''
		}));

		const params = new URLSearchParams(this.props.location.search);
		let unlockCode2 = params.get('c');
		let ecrId = params.get('ecrId');

		this.props
			.verifyUser(ecrId, unlockCode2, this.state.code)
			.then(() => {
				this.props.history.push(authHelpers.buildRouteWithAuthParams('', new URLSearchParams(this.props.location.search)));
			})
			.catch((error) => {
				this.resetFormAndShowError(
					error?.errorMessage ? error?.errorMessage : 'An unknown error has occurred. Please try again later or contact us for assistance.'
				);
			});
	};

	retrieveUnlockCode2 = () => {
		const params = new URLSearchParams(this.props.location.search);
		let unlockCode2 = params.get('c');

		return unlockCode2;
	}

	handleVerificationChange = (event) => {
		const { value } = event.target; // <-- moved outside asynchronous context
		this.setState((state) => ({
			...state,
			code: value.trim(),
		}));
	};

	sendVerificationCode = (successMessage) => {
		const params = new URLSearchParams(this.props.location.search);
		let ecrId = params.get('ecrId');
		let unlockCode2 = params.get('c');
		this.props
			.sendVerificationCode(ecrId, unlockCode2)
			.then(() => {
				this.setState((state) => ({
					...state,
					errorMessage: '',
					successMessage: successMessage ?? '',
					unlockCode2IsInvalid: false,
					statusMessage: ''
				}));
			})
			.catch((error) => {
				this.resetFormAndShowError(
					error?.errorMessage ? error?.errorMessage : 'An unknown error has occurred. Please try again later or contact us for assistance.', true
				);
			});
	}

	resendVerificationcode = async (event) => {
		event.preventDefault();

		this.setState((state) => ({
			...state,
			statusMessage: 'Re-sending one-time code',
			successMessage : ''
		}));
		this.sendVerificationCode('The one-time code has been sent successfuly. Please check your inbox.');
	};

	

	render() {
	
		return (
			<Container maxWidth="sm">
				<>
					{this.state.successMessage ? <><Alert severity="success">{this.state.successMessage}</Alert></> : ''}
					<br />
					{this.state.errorMessage ? <><Alert severity="error">{this.state.errorMessage}</Alert></> : ''}
					<br />

					{this.state.statusMessage ? <><LoadingAlert title="Please wait" message={this.state.statusMessage} /></> : ''}

					{this.state.unlockCode2IsInvalid
						?
						<>
							
						</>
						:
						<>
							<Typography component='h1' variant='subtitle1' className='login-title'>
								<LockIcon style={{ verticalAlign: 'text-bottom', marginRight: 5 }} />
								Verify via email address
							</Typography>

							<Typography color='textSecondary' gutterBottom>
								We have just sent you an email with a one-time code.  Please enter the code below and click Verify:
							</Typography>

							<Divider />

							<form onSubmit={this.handleSubmit}>
								<TextField
									variant='outlined'
									type='text'
									margin='normal'
									value={this.state.code}
									onChange={this.handleVerificationChange}
									required
									fullWidth
									id='code'
									label='One-Time Code'
									name='code'
									InputLabelProps={{
										shrink: true,
									}}
								/>

								<Button type='submit' fullWidth variant='contained' color='primary'>
									Verify
								</Button>
							</form>

							<Box mt={2}>
								<Typography color='textSecondary' gutterBottom>
									Click <b onClick={this.resendVerificationcode} style={{ cursor: 'pointer' }}>here</b> to resend the one-time code.
								</Typography>
							</Box>
						</>
					}
				</>
			</Container>
		);
	}
}

export default connect(
	(state) => state.authentication,
	(dispatch) => bindActionCreators(authActions, dispatch)
)(GuestVerification);
